import * as React from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";

import { Metrics, Palette } from "../../vars";

const propTypes = {
  children: PropTypes.any,
  href: PropTypes.string
};

const MobileToolbarButton: React.SFC<any> = ({
  className,
  href,
  icon,
  onClick
}) => (
  <a href={href} className={className} onClick={onClick}>
    <i className="md-icon">{icon}</i>
  </a>
);

MobileToolbarButton.propTypes = propTypes;

export default styled(MobileToolbarButton)`
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: auto;
  padding: 0 ${Metrics.Padding.MOBILE_TOOLBAR_BUTTON_X}px;
  line-height: ${Metrics.LineHeights.MOBILE_TOOLBAR_BUTTON}px;
  border-left: 1px solid ${Palette.Rebrand.Colours.G2};
  height: 64px;

  .style--rebrand & {
    text-decoration: none;

    &:hover {
      i {
        color: ${Palette.Rebrand.Colours.P2};
      }
    }
  }

  i {
    color: ${Palette.Rebrand.Colours.G6};
    border: 0;
    text-decoration: none;
  }
`;
